export default function AdminUnauthorizedPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-950 px-4 text-center">
      <span className="text-5xl">🔒</span>
      <h1 className="mt-4 text-2xl font-bold text-neutral-100">Access denied</h1>
      <p className="mt-2 max-w-sm text-sm text-neutral-400">
        You passed Cloudflare Access authentication, but your email address hasn't been granted
        app-level admin access yet.
      </p>
      <p className="mt-1 text-sm text-neutral-500">
        Ask an existing admin to add you in the Admin → Access panel.
      </p>
    </div>
  );
}
